var _path, _ellipse, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    width: "1em",
    height: "1em",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.979 20.059L11.252 6.2l7.155-3.835l2.128 1.074l-7.112 4.018l7.348 22.088l-2.364-1.375l-5.5-12.677l-7.22 5.479z",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.24,
    cy: 13.967,
    rx: 2.686,
    ry: 2.503,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 12.85a2.432 2.432 0 0 0-4.157.3a2.188 2.188 0 0 0 .419 2.449A3.544 3.544 0 0 0 27.2 12.85zM19.976 3.4l-1.547-.849L11.693 6.3l.537.29l1.021.537L15.1 6.1l4.877-2.718zm.623-.258a.24.24 0 0 1 .172.161l2.256 6.657a.223.223 0 0 1-.107.29a4.362 4.362 0 0 0-2.106 4.985a4.608 4.608 0 0 0 4.92 3.244a.285.285 0 0 1 .28.172l2.331 6.833a.277.277 0 0 1-.108.3l-7.165 4.189a.268.268 0 0 1-.108.022a.286.286 0 0 1-.193-.032l-2.514-1.58a.251.251 0 0 1-.107-.107l-4.91-11.29l-7.477 4.254a.345.345 0 0 1-.29.011l-1.7-.967a.247.247 0 0 1-.107-.322L10.93 6.178a.26.26 0 0 1 .118-.107l7.241-4.039a.274.274 0 0 1 .258 0zm-8.981 3.702l-.355-.182l-7 13.332l1.278.72l6.038-7.9a.294.294 0 0 1 .247-.108a.3.3 0 0 1 .215.161l6.575 15.148l1.757 1.085l-7.058-20.633l-.3-.86l-1.407-.773zm10.829 7.95a2.727 2.727 0 0 1 1.343-3.115a2.965 2.965 0 0 1 3.481.43a2.719 2.719 0 0 1 .078 3.843l-.078.078a2.932 2.932 0 0 1-4.824-1.236z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpo);
export default __webpack_public_path__ + "static/media/expo.633133ace982480731589fb76157b49c.svg";
export { ForwardRef as ReactComponent };